import { render, staticRenderFns } from "./MasterpieceSelectBottom.vue?vue&type=template&id=fdfb2b2e&scoped=true&"
import script from "./MasterpieceSelectBottom.vue?vue&type=script&lang=js&"
export * from "./MasterpieceSelectBottom.vue?vue&type=script&lang=js&"
import style0 from "./MasterpieceSelectBottom.vue?vue&type=style&index=0&id=fdfb2b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfb2b2e",
  null
  
)

export default component.exports